// day / month / year selects (ISO yyyy-mm-dd) so the date follows the app language, not the browser
export default function DateSel({ value, onChange, testid, empty = true, past = 3 }) {
  const [y, m, d] = (value || '').split('-').map(Number), now = new Date();
  const set = (k, v) => {
    if (v === '') return empty && onChange('');
    const p = { y: y || now.getFullYear(), m: m || now.getMonth() + 1, d: d || now.getDate(), [k]: +v };
    p.d = Math.min(p.d, new Date(p.y, p.m, 0).getDate());
    onChange(`${p.y}-${String(p.m).padStart(2, '0')}-${String(p.d).padStart(2, '0')}`);
  };
  const yrs = Array.from({ length: past + 5 }, (_, i) => now.getFullYear() + 4 - i);
  if (y && !yrs.includes(y)) yrs.unshift(y);
  const sel = (k, v, opts, lab) => (
    <select data-testid={`${testid}-${k}`} value={v || ''} onChange={(e) => set(k, e.target.value)}>
      {empty && <option value="">–</option>}
      {opts.map((o) => <option key={o} value={o}>{lab ? lab(o) : o}</option>)}
    </select>
  );
  return (
    <span className="date-sel" data-testid={testid}>
      {sel('d', d, Array.from({ length: 31 }, (_, i) => i + 1))}
      {sel('m', m, Array.from({ length: 12 }, (_, i) => i + 1), (o) => new Date(2000, o - 1, 1).toLocaleString(undefined, { month: 'short' }))}
      {sel('y', y, yrs)}
    </span>
  );
}
